import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useGetUserFlowQuery } from "../services/api";
import { useAppDispatch, useAppSelector } from "../store/store";
import { setUserFlow } from "../store/reducers/userFlowReducer";
import Loader from "../components/Loader";

const ReloadUserFlowHandler = () => {
  const dispatch = useAppDispatch();
  const { role, Contact_Group } = useAppSelector((state) => state.login);

  const { data: userFlow, isLoading: userFlowLoader } = useGetUserFlowQuery(
    {
      role,
      contactGroup: Contact_Group!,
    },
    {
      skip: !role || !Contact_Group,
    }
  );

  useEffect(() => {
    if (userFlow) {
      dispatch(
        setUserFlow({
          contactGroup: userFlow.data?.contactGroup,
          role: userFlow.data?.rolePermissions
            ? Object.keys(userFlow.data.rolePermissions)[0]
            : role,
          rolePermissions: userFlow.data?.rolePermissions || {},
        })
      );
    }
  }, [userFlow, userFlowLoader, dispatch, role, Contact_Group]);

  if (userFlowLoader)
    return (
      <div className="h-dvh">
        <Loader isLoading={true} />
      </div>
    );

  return <Outlet />;
};

export default ReloadUserFlowHandler;
